import React from "react";
import "./style.css";
import Analitics from "../../assets/img/Analitics.png";

const features = [
  { icon: "⏰", label: "24/7 Help Desk" },
  { icon: "👤", label: "Dedicated Account Manager" },
  { icon: "💬", label: "WhatsApp + Email Support" },
  { icon: "🎫", label: "Ticket Tracking System" },
  { icon: "📋", label: "SLA Commitment" },
  { icon: "📊", label: "Continuous Monitoring" },
];

const stats = [
  { value: "< 2h", label: "Avg. Response Time" },
  { value: "99.9%", label: "Uptime SLA" },
  { value: "24/7", label: "Support Coverage" },
];

export default function TalkToSupport() {
  return (
    <section className="support-section">
      <div className="container">
        <div className="row align-items-center g-5">
          {/* Left Column: Content */}
          <div className="col-lg-6">
            <div className="support-content">
              <h2 className="support-heading">
                Enterprise-Level Support,{" "}
                <span className="support-heading-accent">Every Day</span>
              </h2>

              <p className="support-subtext">
                We back every product we build with serious support
                infrastructure — dedicated managers, real response times, and
                SLA commitments you can hold us to.
              </p>

              {/* Stats row */}
              <div className="support-stats">
                {stats.map((s) => (
                  <div key={s.label} className="support-stat">
                    <span className="support-stat-value">{s.value}</span>
                    <span className="support-stat-label">{s.label}</span>
                  </div>
                ))}
              </div>

              {/* Feature grid */}
              <div className="support-features">
                {features.map((f) => (
                  <div key={f.label} className="support-feature-item">
                    <span className="support-feature-icon">{f.icon}</span>
                    <span className="support-feature-label">{f.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right Column: Analytics Dashboard Card */}
          <div className="col-lg-6">
            <div className="support-visual">
              {/* Glow blobs */}
              <div className="support-glow support-glow--a"></div>
              <div className="support-glow support-glow--b"></div>

              {/* Floating status badge */}
              <div className="support-float-badge">
                <span className="support-status-dot"></span>
                All Systems Operational
              </div>

              {/* Dashboard card */}
              <div className="support-dashboard-card">
                <div className="support-dashboard-header">
                  <span className="dashboard-title">
                    System Health Dashboard
                  </span>
                  <span className="dashboard-live">
                    <span className="live-dot"></span>Live
                  </span>
                </div>
                <div className="support-dashboard-body">
                  <img
                    src={Analitics}
                    alt="System Health Status Dashboard"
                    className="support-health-img"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
